import { helpChatResponseSchema, type HelpChatRequest, type HelpChatResponse } from '@emr/shared';

import { apiRequest } from './client.ts';

/**
 * `POST /api/help/chat` (`BACKLOG.md` B6a). Validated against `@emr/shared`'s own request/response
 * schemas, matching `api/auth.ts`'s own precedent — never a locally-invented approximation that can
 * drift from what the server actually validates.
 */
export async function askHelp(input: HelpChatRequest): Promise<HelpChatResponse> {
  return apiRequest('/api/help/chat', helpChatResponseSchema, {
    method: 'POST',
    body: input,
  });
}
